const tabEvent = new Event('switchToTabEvent');

window.current_tab = null;

//this is global as it can be called from html
window.switchToTab = function (tabId, defEvent) {
    if (defEvent) {
        defEvent.preventDefault();
    }

    var allFormTabs = document.getElementsByClassName("form_tab");
    for(var i = 0; i < allFormTabs.length; i++) {
        allFormTabs[i].style.display = 'none';
    }

    window.current_tab = tabId;
    window.scrollTo(0, 0);

    document.getElementById(tabId).style.display = 'block';
    //window.location.hash = tabId;
    window.dispatchEvent(tabEvent);
};

window.addEventListener('popstate', function(e) {

    if (!window.current_tab) {
        window.history.back();

        return;
    }
});

module.exports={ switchToTab: window.switchToTab };
